import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_44_1M_44',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_44_1m_44_usd',
			EUR: 'simple_premium_1m_44_1m_44_eur',
			GBP: 'simple_premium_1m_44_1m_44_gbp',
			CAD: 'simple_premium_1m_72_1m_72_cad',
			AUD: 'simple_premium_1m_72_1m_72_aud',
			DKK: 'simple_premium_1m_379_1m_379_dkk',
			NOK: 'simple_premium_1m_579_1m_579_nok',
			SEK: 'simple_premium_1m_579_1m_579_sek',
			TRY: 'simple_premium_1m_1429_1m_1429_try',
			BRL: 'simple_premium_1m_179_1m_179_brl',
			MXN: 'simple_premium_1m_729_1m_729_mxn',
			ARS: 'simple_premium_1m_58699_1m_58699_ars',
			COP: 'simple_premium_1m_175999_1m_175999_cop',
			CLP: 'simple_premium_1m_44000_1m_44000_clp',
		},
		primer: 'prd_4NTYz5Tu3L4K',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			CAD: 72,
			AUD: 72,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
		originalPriceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			CAD: 72,
			AUD: 72,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			CAD: 72,
			AUD: 72,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 179,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.30_days.period_text'), // '1-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		updatedTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
	}),
}
